/** 浏览器 / 微信各自的背景音量；提示音相对背景固定高 5 dB。 */
export const BGM_VOLUME_BROWSER = 0.55;
export const BGM_VOLUME_WECHAT = 0.4;
export const SFX_DB_ABOVE_BGM = 5;

export function sfxVolume(bgmVolume: number): number {
  return Math.min(1, bgmVolume * 10 ** (SFX_DB_ABOVE_BGM / 20));
}
